"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { pageViewEventFor } from "@/lib/analytics/page-view";
import { getOrCreateAnonymousId, getOrCreateSessionId, updateAttributionFromLocation } from "@/lib/analytics/session";
import { trackEvent } from "@/lib/analytics/track";
import { customerSiteAnalyticsContext } from "@/lib/analytics/customer-site";

export default function AnalyticsClient() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastKey = useRef<string | null>(null);

  useEffect(() => {
    if (!customerSiteAnalyticsContext(window.location.hostname, window.location.pathname)) return;
    // Prime ids and attribution early for all later events.
    getOrCreateSessionId();
    getOrCreateAnonymousId();
    updateAttributionFromLocation();
  }, []);

  useEffect(() => {
    if (!customerSiteAnalyticsContext(window.location.hostname, window.location.pathname)) return;
    const search = searchParams?.toString() ? `?${searchParams.toString()}` : "";
    const key = `${pathname}${search}`;
    if (lastKey.current === key) return;
    lastKey.current = key;

    // Optional override: allow forcing sold-out view via query flag (useful for landing links).
    const soldOutFlag = searchParams?.get("sold_out");
    if (soldOutFlag && soldOutFlag !== "0" && soldOutFlag !== "false") {
      trackEvent("view_sold_out", { source: "query_flag" });
      return;
    }

    const ev = pageViewEventFor(pathname);
    if (!ev) return;
    trackEvent(ev.name, ev.props);
  }, [pathname, searchParams]);

  return null;
}
